import React, { useState } from 'react';
import { Input, Button, InputSizes } from '@clockout-dev/design-elements';
import styles from './styles/freeAdvances.module.scss';

/** Manual single-member add row, used inside PromoGroupDrawer's roster. */
function MemberIdEditor({ onAdd, disabled }) {
    const [draft, setDraft] = useState('');

    const submit = () => {
        const trimmed = draft.trim();
        if (!trimmed) return;
        onAdd(trimmed);
        setDraft('');
    };

    return (
        <div className={styles.memberInputRow}>
            <Input
                size={InputSizes.SMALL}
                label="Member ID"
                placeholder="Enter member ID…"
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        submit();
                    }
                }}
                classNames={{ root: styles.memberInput }}
                disabled={disabled}
            />
            <Button
                type="button"
                className={styles.memberAddButton}
                onClick={submit}
                disabled={disabled || !draft.trim()}
            >
                Add
            </Button>
        </div>
    );
}

export default MemberIdEditor;
